export default function ({ app, $axios, $config }) {
	let apiBaseUrl = $config.apiBaseUrl[app.i18n.locale] + '/api';
	$axios.interceptors.request.use(config => { config.baseURL = apiBaseUrl; return config; }, error => Promise.reject(error));
}
